import { render, staticRenderFns } from "./LevelComponent.vue?vue&type=template&id=15f20334&scoped=true"
import script from "./LevelComponent.vue?vue&type=script&lang=js"
export * from "./LevelComponent.vue?vue&type=script&lang=js"
import style0 from "./LevelComponent.vue?vue&type=style&index=0&id=15f20334&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f20334",
  null
  
)

export default component.exports